import { render, staticRenderFns } from "./SeatSVG.vue?vue&type=template&id=18afa569&scoped=true&"
import script from "./SeatSVG.vue?vue&type=script&lang=js&"
export * from "./SeatSVG.vue?vue&type=script&lang=js&"
import style0 from "./SeatSVG.vue?vue&type=style&index=0&id=18afa569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18afa569",
  null
  
)

export default component.exports